import React, { useState } from 'react';
import { useAuth } from '../auth/useAuth';
import { useCart } from './CartContext';
import '../styles/AddToCartButton.css';

interface AddToCartButtonProps {
  productId: number;
  inStock: boolean;
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({ productId, inStock }) => {
  const { isAuthenticated, login } = useAuth();
  const { addToCart } = useCart();
  const [adding, setAdding] = useState(false);
  const [added, setAdded] = useState(false);

  const handleClick = async () => {
    if (!isAuthenticated) {
      login();
      return;
    }
    if (!inStock) return;

    setAdding(true);
    try {
      await addToCart(productId);
      setAdded(true);
      setTimeout(() => setAdded(false), 1500);
    } catch {
      // silently fail
    } finally {
      setAdding(false);
    }
  };

  return (
    <button
      className={`add-to-cart-btn ${added ? 'added' : ''}`}
      onClick={handleClick}
      disabled={!inStock || adding}
    >
      {!inStock ? 'Out of Stock' : adding ? 'Adding...' : added ? '✓ Added' : 'Add to Cart'}
    </button>
  );
};

export default AddToCartButton;
